/**
 * better to ask Felix if you're not sure if something is general term or not
 * do not mistake with "simple" translations like "submit" or "cancel"
 * never use for composition
 *
 * generalTerm translations are something, which are specific to project "domain" or "project"
 * "common" translations are everything, which can be reused across different projects
 *
 * TODO: extract "common" above this object in order to reuse some translations
 */
export const generalTerm = {
  CCTDiagram: 'Diagram CCT',
  area: 'Obszar | Obszary',
  asset: 'Zasób',
  assetId: 'Identyfikator zasobu',
  assetType: 'Typ zasobu',
  austenite: 'Austenit',
  automat: 'Automat | Automaty',
  carbonPotential: 'Potencjał węglowy',
  chamber: 'Izba | Izby',
  chart: 'Wykres | Wykresy',
  color: 'Kolor',
  company: 'Firma | Firmy',
  component: 'Komponent | Komponenty',
  composition: 'Kompozycja',
  createdAt: 'Utworzono w',
  createdBy: 'Utworzone przez',
  deletedAt: 'Usunięto dnia',
  deletedBy: 'Usunięte przez',
  deleted: 'Usunięto',
  customer: 'Klient',
  data: 'Dane',
  dataSourceId: 'Źródło danych',
  dataSourceReference: 'Odniesienie do źródła danych',
  date: 'Data',
  description: 'Opis',
  displayName: 'Nazwa',
  drawingReference: 'Odniesienie do rysunku',
  element: 'Element | Elementy',
  email: 'E-mail',
  envelope: 'Koperta',
  equipment: 'Zasób | Zasoby',
  equipmentGroup: 'Grupa zasobów | Grupy zasobów',
  event: 'Wydarzenie | Wydarzenia',
  fullName: 'Pełne imię i nazwisko',
  gasComposition: 'Skład gazu',
  generalInformation: 'Informacje ogólne',
  heatTreatmentCapability: 'Możliwości obróbki cieplnej | Możliwości obróbki cieplnej',
  heatTreatmentProcess: 'Proces obróbki cieplnej | Procesy obróbki cieplnej',
  height: 'Wysokość',
  job: 'Praca | Praca',
  jobDisplayName: 'Załaduj nr',
  jobFinishedAtUtc: 'Czas końcowy',
  jobId: 'Identyfikator zadania',
  jobStartedAtUtc: 'Czas rozpoczęcia',
  jominyDiagram: 'Krzywa Jominy\'ego',
  lastModifiedAt: 'Zmodyfikowano dnia',
  lastModifiedBy: 'Zmodyfikowane przez',
  limitMinus: 'Limit -',
  limitPlus: 'Limit +',
  loadIdentifier: 'Identyfikator obciążenia',
  location: 'Lokalizacja | Lokalizacje',
  locationId: 'Identyfikator lokalizacji',
  machine: 'Maszyna | Maszyny',
  manufacturer: 'Producent',
  mappedPT9800user: 'Zmapowany użytkownik Protherm',
  material: 'Materiał',
  materialCalculationModel: 'Model obliczeniowy materiałów',
  materialSystemList: 'Systemy materiałowe',
  measure: 'Miara | Miary',
  name: 'Nazwa',
  nitrogenPotential: 'Potencjał azotowy',
  orientation: 'Orientacja',
  overwrite: 'Nadpisz',
  part: 'Część',
  partId: 'Identyfikator części',
  partNumber: 'Numer części',
  preference: 'Preferencje | Preferencje',
  preset: 'Ustawienie wstępne',
  processFlow: 'Przepływ procesów | Przepływy procesów',
  processValuesChart: 'Wykres wartości procesu',
  production: 'Produkcja',
  profileChart: 'Wykres profilu',
  profileTable: 'Tabela profili',
  recipe: 'Receptura | Receptury',
  recipeStage: 'Etap receptury',
  recipeStep: 'Krok',
  report: 'Raport',
  reportId: 'Numer raportu',
  reporter: 'Zgłaszający',
  requirement: 'Wymóg',
  result: 'Wynik',
  revision: 'Rewizja',
  root: 'Korzeń | Korzenie',
  scadaType: 'Typ Scada',
  schaefflerDiagram: 'Schäffler Diagramm',
  send: 'Wyślij',
  sensor: 'Czujnik',
  setpoint: 'Punkt nastawy | Punkty nastawy',
  showDeleted: 'Pokaż usunięte',
  signal: 'Sygnał | Sygnały',
  sms: 'SMS-y',
  sparePart: 'Część zamienna | Części zamienne',
  step: 'Krok',
  surfaceCarbide: 'Węglik powierzchniowy',
  surfaceCarbon: 'Węgiel powierzchniowy',
  surfaceNitrogen: 'Azot powierzchniowy',
  temperingCurveDiagram: 'Krzywa hartowania',
  title: 'Tytuł',
  unit: 'Jednostka | Jednostki',
  upload: 'Załaduj',
  width: 'Szerokość',
  zone: 'Strefa | Strefy',

  // Diffusion / simulation inputs — shared by the Diffusion Inputs panel
  // (form-pt9800-diffusion-inputs.vue) and the /simulator page. Wording mirrors the simulator.
  alloyFactor: 'Współczynnik stopu C',
  carbonContent: 'Zawartość węgla rdzeniowego',
  carbideLimit: 'Granica węglików',
  carbonMonoxide: 'Tlenek węgla CO',
  hydrogen: 'Wodór H₂',
  quenchingIntensity: 'Intensywność gaszenia',
  representativeDiameter: 'Reprezentatywna średnica próbki (DIN 17211)',
  requiredHardness: 'Efektywna twardość obudowy',
  grainSize: 'Numer wielkości ziarna ASTM',
  endTemperature: 'Temperatura końcowa',
  carburizingDepth: 'Głębokość nawęglania',
  nitridingDepth: 'Głębokość twardości efektywnej (NHD)',
  referenceCarbon: 'Węgiel na głębokości węglowodoru',
  targetSurfaceCarbon: 'Docelowy węgiel powierzchniowy',
};

// used in tables or other places where you need to filter by general term
export const generalTermFilter = {
  asset: 'Wyszukaj zasób',
};
